import { useGetRenkiTag } from 'gen/client';

export function useTagHasOwner(serial: string) {
    const { data, error, isLoading, mutate } = useGetRenkiTag(serial, {
        swr: {
            enabled: Boolean(serial),
            refreshInterval: 0,
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            shouldRetryOnError: false,
        },
    });
    const hasOwnerCompany = Boolean(data?.tag?.customer_company);
    const hasOwnerGroup = Boolean(data?.tag?.customer_group);
    const hasOwnerInstance = Boolean(data?.tag?.customer_instance);
    const hasOwnerUser = Boolean(data?.tag?.customer_user);
    const hasOwner = Boolean(hasOwnerCompany || hasOwnerGroup || hasOwnerInstance || hasOwnerUser);

    return { error, hasOwner, isLoading, mutate };
}
